// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyDlMgLb1nHI5XOeW6GO6l0qxIOIEd6soTc",
//   authDomain: "helium-education.firebaseapp.com",
//   projectId: "helium-education",
//   storageBucket: "helium-education.appspot.com",
//   messagingSenderId: "952171986107",
//   appId: "1:952171986107:web:50053457a5b7ac18477d9e",
//   measurementId: "G-4393WLHCZ1"
// };

const firebaseConfig = {
  apiKey: "AIzaSyCJqniHQXE-2grZv5CURc_BOzRmKbT58sM",
  authDomain: "helium-learning.firebaseapp.com",
  projectId: "helium-learning",
  storageBucket: "helium-learning.appspot.com",
  messagingSenderId: "339406662292",
  appId: "1:339406662292:web:0848af7b1478972ddde281",
  measurementId: "G-H18WXRLKHH"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

export { auth,app }